/**
 * Article Feedback actions
 */
import { createAction, ActionsUnion } from '../utils/types';

export enum ActionTypes {
  FEEDBACK_REACTION_PRESSED = 'articleFeedback::feedback_reaction_pressed',
  FEEDBACK_REACTION_SUBMITTED = 'articleFeedback::feedback_reaction_submitted',
  FEEDBACK_REACTION_ERROR = 'articleFeedback::feedback_reaction_error',
  NEGATIVE_FEEDBACK_SKIPPED = 'articleFeedback::negative_feedback_skipped',
  NEGATIVE_FEEDBACK_SUBMIT = 'articleFeedback::negative_feedback_submit',
  NEGATIVE_FEEDBACK_SUBMIT_ERROR = 'articleFeedback::negative_feedback_submit_error',
  NEGATIVE_FEEDBACK_SUBMIT_SUCCESS = 'articleFeedback::negative_feedback_submit_success',
}

type FeedbackFormData = {
  email?: string;
  feedback: string;
};

export const Actions = {
  feedbackReactionPressed: (
    articleId: string,
    title: string,
    isPositive: boolean
  ) =>
    createAction(ActionTypes.FEEDBACK_REACTION_PRESSED, {
      articleId,
      title,
      isPositive,
    }),

  feedbackReactionSubmitted: (articleId: string, isPositive: boolean) =>
    createAction(ActionTypes.FEEDBACK_REACTION_SUBMITTED, {
      articleId,
      isPositive,
    }),

  feedbackReactionError: (articleId: string, isPositive: boolean) =>
    createAction(ActionTypes.FEEDBACK_REACTION_ERROR, {
      articleId,
      isPositive,
    }),

  negativeFeedbackSkipped: (articleId: string) =>
    createAction(ActionTypes.NEGATIVE_FEEDBACK_SKIPPED, {
      articleId,
    }),

  negativeFeedbackSubmit: (
    articleId: string,
    title: string,
    formData: FeedbackFormData
  ) =>
    createAction(ActionTypes.NEGATIVE_FEEDBACK_SUBMIT, {
      articleId,
      title,
      formData,
    }),

  negativeFeedbackSubmitError: (articleId: string) =>
    createAction(ActionTypes.NEGATIVE_FEEDBACK_SUBMIT_ERROR, {
      articleId,
    }),

  negativeFeedbackSubmitSuccess: (articleId: string) =>
    createAction(ActionTypes.NEGATIVE_FEEDBACK_SUBMIT_SUCCESS, {
      articleId,
    }),
};

export type Actions = ActionsUnion<typeof Actions>;
